import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { actions } from 'store/newDocumentStore';
import DocumentLoader from 'routes/Documents/containers/DocumentLoaderContainer';
import DocumentProvider from 'routes/Documents/containers/DocumentProvider';

import OnlineRehabilitation from '../components/OnlineRehabilitation';

const OnlineRehabilitationContainer = ({ edit, create }) => (
  <DocumentLoader names={['onlineRehabilitation', 'status', 'eq5d', 'msnq', 'fsmc', 'fatigueTrackingDiary']}>
    <DocumentProvider editingDocumentType="onlineRehabilitation">
      <OnlineRehabilitation onStartEdit={edit} onCreate={create} />
    </DocumentProvider>
  </DocumentLoader>
);

OnlineRehabilitationContainer.propTypes = {
  edit: PropTypes.func,
  create: PropTypes.func,
};

export default connect(null, { edit: actions.createCommit, create: actions.createDocumentAndCommit })(
  OnlineRehabilitationContainer,
);
